module.exports = __webpack_public_path__ + "static/media/residentiel-10.ba528400.jpg";